import { createReducer } from 'typesafe-actions';
import { TFavoritesActions, favoritesActions } from './favorites-reducer-actions';

export interface IFavoritesItemPayload {
    object_id: number,
    layer_code: string;
}

export interface IFavoritesState {
    items: Record<string, number[]>;
}

const defaultState: IFavoritesState = {
    items: {}
};

export const favoritesReducer = createReducer<IFavoritesState, TFavoritesActions>(defaultState)
    .handleAction(favoritesActions.setItems, (state, action) => ({
        ...state,
        items: action.payload
    }));
